<template>
  <div class="stats-list">
    <div class="stat" v-for="item in items" :key="item.id">
      <slot name="stat-item" :item="item">
        <div class="stat-value">{{ formatNumber(item.valueType, item.value) }}</div>
        <div class="stat-description">{{ $t('message.' + item.description) }}</div>
      </slot>
    </div>
  </div>
</template>

<script>
const numberFormats = {
  cad: { maximumFractionDigits: 0, minimumFractionDigits: 0, style: 'currency', currency: 'CAD' },
  number: {}
}
export default {
  props: {
    items: {
      type: Array,
      default: () => [
        {
          id: 'stat1',
          description: 'Ventes',
          value: 280,
          valueType: 'number'
        },
        {
          id: 'stat2',
          description: 'Clients',
          value: 40,
          valueType: 'number'
        },
        {
          id: 'stat3',
          description: 'Commandes',
          value: '400 $',
          valueType: 'cad'
        }
      ]
    }
  },
  methods: {
    formatNumber (type, value) {
      return new Intl.NumberFormat('fr-CA', numberFormats[type]).format(value)
    }
  }
}
</script>

<style lang="scss">
.stats-list {
  margin-top: 48px;
  .stat {
    margin: 48px 0;
    &-value {
    margin: 4px 0;
    font-family: 'geomanist-light';
    font-size: 3rem;
    font-weight: 300;
    }
    &-description {
      font-size: 1rem;
      letter-spacing: 0.2px;
      color: #6e707a;
    }
  }
}
</style>
